// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  webAuth: true,
  hmr: false,
  apiUrl: 'https://backend.unrestricted.eu',
  firebase: {
    apiKey: 'AIzaSyDouO3HNcFfZaGZngrFQHVQr3_ZzzpbvAs',
    authDomain: 'unrestricted-9b98d.firebaseapp.com',
    databaseURL: 'https://unrestricted-9b98d.firebaseio.com',
    projectId: 'unrestricted-9b98d',
    storageBucket: 'unrestricted-9b98d.appspot.com',
    messagingSenderId: '1068391120764'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
